class DocumentationPathData {

    constructor() {

        this._BLOCKER_SEQUENTIAL_BY_CONTENT = 1;
        this._BLOCKER_SEQUENTIAL_BY_SECTION = 2;
        this._BLOCKER_PLANNER_DATE = 7;

        this._PATH_NOT_STARTED = "NOT_STARTED";
        this._PATH_IN_PROCESS = "IN_PROCESS";
        this._PATH_COMPLETED = "COMPLETED";

        this._PATH_TEST_NOT_STARTED = "NOT_STARTED";
        this._PATH_TEST_IN_PROCESS = "IN_PROCESS";
        this._PATH_COMPLETED = "COMPLETED";

        this._PATH_ASSESSMENT_LOW_LEVEL = "LOW";
        this._PATH_ASSESSMENT_MEDIUM_LEVEL = "MEDIUM";
        this._PATH_ASSESSMENT_HIGH_LEVEL = "HIGH";

        this._ACTION_BUTTON_INDEX = "index";
        this._ACTION_BUTTON_INFORMATION = "information";
        this._ACTION_BUTTON_MATERIALS = "materials";
        this._ACTION_BUTTON_FAVOURITE = "favourite";
        this._ACTION_BUTTON_COMMENT = "comment";
        this._ACTION_BUTTON_LIKE = "like";

        this._indexOpened = false;
        this._pathDocumentId = null;
        this._pathData = null;
        this._pathStatus = "";
        this._pathTestStatus = "";

    }

    getIsIndexOpened() {
        return this._indexOpened;
    }

    getPathData() {
        // Path type Cover
        if (this._pathData.mode === 1) {
            this._pathData.sections = this._pathData.sections.map(section => {
                const sectionCounter = (this._pathData.sections ?? []).length > 1;
                const header = {
                    ...section.header,
                    left: {
                        has_completion: true,
                    },
                    right: {
                        has_accordion: true,
                        has_contents_counter: true,
                        has_progress_bar: false,
                        has_view_all: false,
                    }
                };

                return {
                    ...section,
                    header: sectionCounter ? header : null,
                }
            });

            return this._pathData;
        }

        return this._pathData;
    }

    getAssessmentLevels() {

        const assessmentLevels = {
            LOW: this._PATH_ASSESSMENT_LOW_LEVEL,
            MEDIUM: this._PATH_ASSESSMENT_MEDIUM_LEVEL,
            HIGH: this._PATH_ASSESSMENT_HIGH_LEVEL
        }

        return assessmentLevels;

    }

    getBlockers() {

        const blockers = {
            BLOCKER_SEQUENTIAL_BY_CONTENT: this._BLOCKER_SEQUENTIAL_BY_CONTENT,
            BLOCKER_SEQUENTIAL_BY_SECTION: this._BLOCKER_SEQUENTIAL_BY_SECTION,
            BLOCKER_PLANNER_DATE: this._BLOCKER_PLANNER_DATE,
        };

        return blockers;

    }

    getButtonActionTypes() {

        return {

            ACTION_BUTTON_INDEX: "index",
            ACTION_BUTTON_INFORMATION: "information",
            ACTION_BUTTON_MATERIALS: "materials",
            ACTION_BUTTON_FAVOURITE: "favourite",
            ACTION_BUTTON_COMMENT: "comment",
            ACTION_BUTTON_LIKE: "like"

        }

    }

    getCompletedDocuments() {
        return this._pathData.completedDocuments;
    }

    getPathDocumentId() {
        return this._pathDocumentId;
    }

    setIndexOpened(opened) {
        this._indexOpened = opened;
    }

    setPathData(data) {
        this._pathData = data;
    }

    setPathDocumentId(pathDocumentId) {
        this._pathDocumentId = pathDocumentId;
    }

    updateProgressStatePercentage() {
        let totalItems = 0;
        let completedItems = 0;

        this._pathData.sections.forEach((section) => {
            totalItems += section.items.length;

            completedItems += section.items.reduce((acc, current) => {
                if (current.completed) {
                    return acc + 1;
                }

                return acc;
            }, 0);
        }, 0);

        const percentage = Math.round((completedItems / totalItems) * 100);

        this._pathData.progressState.percentage = percentage;

        if(percentage > 0 && percentage < 99) {
            this._pathData.progressState.state = this._PATH_IN_PROCESS;
        } else if (percentage > 99) {
            this._pathData.progressState.state = this._PATH_COMPLETED;
        }
    }

    updatePathDocument(sectionId, documentId, _updatedItem = null ) {
        const updatedItem = _updatedItem ? _updatedItem : { completed: true, isBlocked: false,progressState: 'COMPLETED'};

        const newPathData = this._pathData.sections.map(section => {
            if (section.id === sectionId) {
                const updatedItems = section.items.map(item => {
                    if (item.id === documentId) {
                        return {
                            ...item,
                            ...updatedItem,
                        }
                    }

                    return item;
                });

                return {
                    ...section,
                    items: updatedItems,
                }
            }

            return section;
        });

        this._pathData.sections = newPathData;
    }

}